import { CheckBoldIcon } from '../Icon';

// The state matrix uses the same glyph as the live selected row.
export const SelectCheckMark = () => <CheckBoldIcon />;
